import { render, staticRenderFns } from "./contraction.vue?vue&type=template&id=597fb7a6&scoped=true"
import script from "./contraction.vue?vue&type=script&lang=js"
export * from "./contraction.vue?vue&type=script&lang=js"
import style0 from "./contraction.vue?vue&type=style&index=0&id=597fb7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597fb7a6",
  null
  
)

export default component.exports